import React from "react";

export const LeaderboardsLocked: React.FC = () => {
	return (
		<div>
			<p>The Beast Academy Leaderboards have been turned off for you.</p>
			<p>
				If you'd like to view and participate in the Beast Academy Leaderboards,
				ask your parent to turn them on for you. Your parent can turn on
				Leaderboards at their Accounts page on BeastAcademy.com.
			</p>
		</div>
	);
};
